"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Image = ({
  src,
  alt,
  width = 100,
  center = true,
  style
}) => {
  const isTypeString = typeof src === 'string' || src instanceof String;
  return _react.default.createElement(_react.default.Fragment, null, isTypeString ? _react.default.createElement("img", {
    src: src,
    alt: alt,
    style: {
      display: center ? 'block' : 'inline-block',
      width: width !== 'auto' ? `${width}%` : 'auto',
      margin: 'auto',
      ...style
    }
  }) : _react.default.cloneElement(src, {
    style: {
      display: center ? 'block' : 'inline-block',
      width: width !== 'auto' ? `${width}%` : 'auto',
      margin: 'auto',
      ...style
    }
  }));
};

var _default = Image;
exports.default = _default;